let host = location.host;
let TestSite = ['aemtest.com', 'store-rev.modd.com'];
const dev_domain = 'https://stg.fc.stage-toukenranbu.jp/';
// const dev_domain = 'https://fc.stage-toukenranbu.axdv.me';
const run_domain = 'https://fc.stage-toukenranbu.jp/';
let domain = run_domain;

if (TestSite.indexOf(host) == 1) {
    domain = dev_domain
}

$(function () {
    let $body = $('body');
    let bodyId = $body.attr('id');

    if (bodyId === 'Login') {
        Login();
    }else if (bodyId === 'Register') {
        Register();
    } else if (bodyId === 'RegisterStep1') {
        RegisterStep1();
    } else if (bodyId === 'RegisterFin') {
        RegisterFin();
    } else if (bodyId === 'LogoffFin') {
        LogoffFin();
    } else if (bodyId === 'CustomerDelFin') {
        CustomerDelFin();
    } else if (bodyId === 'CustomerEditFin') {
        CustomerEditFin();
    } else if (bodyId === 'MyPage') {
        MyPage();
    } else if (bodyId === 'fcRegisterStep1') {
        fcRegisterStep1();
    } else if (bodyId === 'fcPayment') {
        fcPayment();
    } else if (bodyId === 'fcPaymentDetails') {
        fcPaymentDetails();
    } else if (bodyId === 'fcPayComp') {
        fcPayComp();
    } else if (bodyId === 'fcPay') {
        fcPay();
    } else if (bodyId === 'fcJoinEntry') {
        fcJoinEntry();
    } else if (bodyId === 'fcJoinMail') {
        fcJoinMail();
    } else if (bodyId === 'fcKiyaku') {
        fcKiyaku();
    } else if (bodyId === 'FcCarrierAuthorize') {
        FcCarrierAuthorize();
    } else if (bodyId === 'FcWithdraw') {
        FcCarrierAuthorize();
    } else if (bodyId === 'com_kiyaku') {
        com_kiyaku();
    } else if (bodyId === 'com_help') {
        com_help();
    } else if (bodyId === 'com_contact') {
        com_contact();
    } else if (bodyId === 'CheckOut') {
        CheckOut();
    } else if (bodyId === 'com_tokutei') {
        com_tokutei();
    } 
    else if (bodyId === 'fcJoin') {
        fcJoin();
    }

    // リンク先変更
    $('#cmnhead_button_help').removeClass('link_autorep').attr('href', domain + '/faq/')
    $('#cmnhead_button_contact').removeClass('link_autorep').attr('href','/v2/help/com_contact.aspx?ccode=TOKN')
    // $('#cmnhead_button_contact').removeClass('link_autorep').attr('href','/v2/help/contact.aspx?ccode=TOKN')

    // 会員登録フローガイド
    $('.flow_guide').each(function () {
        let $firstFlow = $(this).find('li:first-child');
        if($firstFlow.text().indexOf('1.会員規約を確認') > -1) {
            $firstFlow.text('1.利用規約を確認');
        }
    });
});

// fcJoin
function fcJoinMail() {
    $('#panel_sendmail .message_area').before('※プレオープン期間中に無料会員にご登録いただいた皆様、または過去ファンサイトにご入会いただいていた皆様は<a href="/v2/Login.aspx?ccode=TOKN&fcm=TOKN&ReturnUrl=%2fv2%2fmember%2ffcKiyaku.aspx%3fccode%3dTOKN%26fcm%3dTOKN">こちら</a>より、決済情報のお手続きをお願い致します。')
}

// fcJoinEntry
function fcJoinEntry() {
    setTimeout(function() {
        $('#card_fc_auto').prop('checked', true);
    },300)
    $('#payCarrier_paymentSB_Panel').after('<a href="' + domain +'/faq/#24">会員有効期限／継続のお手続きについてはこちらをご確認ください</a>')
}

// Login
function Login() {
    $('.panel-heading.sinki_header.register_linktype1').text('舞台『刀剣乱舞』公式通販会員登録(無料)はこちら');
    $('#sinki_annnounce').text('刀ステファンサイト会員登録(有料)はこちら');
    $('.fc_register_table').insertAfter('.title_bar');
    $('.fc_register_table').hide();
}

// Register
function Register() {
    $('#SendBtn').before('<h4 class="col-xs-12 t_message_center mb-30"><a class="link_ec" href="https://ec.stage-toukenranbu.jp/info/kiyaku/" target="_blank">利用規約</a>、<a class="link_ec" href="/v2/help/privacy.aspx?ccode=TOKN" target="_blank">プライバシーポリシー</a>に同意の上、次へ進む</h4>');
    $('.t_title').text('舞台『刀剣乱舞』公式通販会員登録(無料)');
    $('.table_control > .message_area').before('<p>◆現在刀ステファンサイトに入会している、もしくは過去に入会したことがある方</p>')
    $('.table_control > .message_area').before('<p>◆プレオープン期間中に無料会員にご登録いただいた方<br>ご登録のメールアドレス（または会員番号）とパスワードでご利用が可能です。<br>ログインボタンよりログインの上、お進みください。</p>')
}


// RegisterStep1
function RegisterStep1() {
    $('.link_ec').each(function () {
        if($(this).text().indexOf('会員規約') > -1) {
            $(this).text('利用規約');
        }
    });

    $('#RegisterNextBtn').before('※「刀ステファンサイト」「舞台『刀剣乱舞』公式通販」では、ご登録メールアドレス宛に、不定期でメールを配信することがございます。<br>同意いただける方は「次へ進む」ボタンをご選択ください。');
}


// RegisterFin
function RegisterFin() {
    $('.alert').each(function(){
        let $alert = $(this);

        $alert.after('<a class="btn-100" href="/v2/Login.aspx?ccode=TOKN">ログインはこちら</a>');
    });
}


// LogoffFin
function LogoffFin() {
    $('.alert').each(function(){
        let $alert = $(this);

        $alert.after('<a class="btn-100" href="https://stage-toukenranbu.jp/index.html">TOPはこちら</a>');
    });
}


// CustomerDelFin
function CustomerDelFin() {
    $('.alert').each(function(){
        let $alert = $(this);

        $alert.after('<a class="btn-100" href="https://stage-toukenranbu.jp/index.html">TOPはこちら</a>');
    });
}


// CustomerEditFin
function CustomerEditFin() {
    $('.alert').each(function(){
        let $alert = $(this);

        $alert.text('ご登録ありがとうございます。会員情報を変更しました。');
    });
}


// MyPage
function MyPage() {
    // アコーディオンを開いておく
    $('.table_collapse_link').removeClass('collapsed').attr('aria-expanded', 'true');
    $('.glyphicon').removeClass('glyphicon-chevron-left').addClass('glyphicon-chevron-down');
    $('.table_collapse').addClass('in');

    // 各種履歴非表示
    // $('#history_order').hide();
    $('#history_preorder').hide();

    $('.vct_fanclub').each(function () {
        if ($(this).text().indexOf('ファンクラブの入会情報はありません') > -1) {
            $(this).text('ファンサイトの入会情報はありません');
        }
    });

    $('.table_header').each(function () {
        if ($(this).text().indexOf('ファンクラブ情報') > -1) {
            $(this).text('ファンサイト情報');
        } else if ($(this).text().indexOf('受付中のファンクラブ') > -1) {
            $(this).text('受付中のファンサイト');
        }
    });

    $('.link_mypage').each(function () {
        if ($(this).text().indexOf('ファンクラブ情報の登録（会員番号をお持ちの方）') > -1) {
            $(this).text('ファンサイト情報の登録（会員番号をお持ちの方）');
        }
    });
}

function fcRegisterStep1() {
    $('.t_message').each(function () {
        if ($(this).text().indexOf('ファンクラブ会員情報を入力してください') > -1) {
            $(this).text('ファンサイト会員情報を入力してください');
        }
    });

    $('.table_label').each(function () {
        if ($(this).text().indexOf('ファンクラブ') > -1) {
            $(this).text('ファンサイト');
        }
    });
}

function fcPayment() {
    $('.tbllst_itemlabel').each(function () {
        if ($(this).text().indexOf('ファンクラブ') > -1) {
            $(this).text('ファンサイト');
        }
    });
}

function fcPaymentDetails() {
    $('.table_label').each(function () {
        if ($(this).text().indexOf('ファンクラブ名') > -1) {
            $(this).text('ファンサイト名');
        }
    });
}

function fcPayComp() {
    $('input').addClass('btn-100')
    $('.t_message').text('引き続きお支払い手続きを行なってください。');
    $('.t_message').after('<p>※お支払い手続きが完了しますと会員限定コンテンツがご利用いただけるようになります。</p>');

}

function fcPay() {
    setTimeout(function() {
        $('#card_fc_auto').prop('checked', true);
    },300)
    $('#payCarrier_paymentSB_Panel').after('<a href="' + domain + '/faq/#24">会員有効期限／継続のお手続きについてはこちらをご確認ください</a>')
}

function fcKiyaku() {
    $('.t_message').each(function () {
        if($(this).text().indexOf('会員規約を必ずお読みいただき、同意した上でお申込み手続きをおこなってください。') > -1) {
            $(this).text('利用規約を必ずお読みいただき、同意した上でお申込み手続きをおこなってください。');
        }
    });

    $('#fccontinue_txt').each(function () {
        if ($(this).text().indexOf('ファンクラブ入会申込み') > -1) {
            $(this).text('ファンサイト入会申込み');
        }
    });

    $('.kiyaku_header').each(function () {
        if($(this).text().indexOf('会員規約') > -1) {
            $(this).text('利用規約');
        }
    });
}

function fcJoin() {
    $('.t_title').each(function () {
        if ($(this).text().indexOf('ファンクラブ入会申込み') > -1) {
            $(this).text('ファンサイト入会申込み');
        }
    });
}

function FcCarrierAuthorize() {
    $('.table_label').each(function () {
        if ($(this).text().indexOf('ファンクラブ名') > -1) {
            $(this).text('ファンサイト名');
        }
    });
}

function com_kiyaku() {
    $('.link_fc').each(function () {
        if($(this).text().indexOf('ファンクラブに関する会員規約はこちら') > -1) {
            $(this).text('ファンサイトに関する利用規約はこちら');
        }

        $('.link_ec').each(function () {
            let $link = $(this),
                href = $link.attr('href');
            
            setTimeout(function () {
                if (href.indexOf('kiyaku') > -1) {
                    if (TestSite.indexOf(host) != -1) {
                        $link.attr('href', '//ec.stage-toukenranbu.axdv.me/info/kiyaku/');
                    } else {
                        $link.attr('href', '//ec.stage-toukenranbu.jp/info/kiyaku/');
                    }
                } 
            }, 100);
        });
    });
}

function com_help() {
    $('.link_fc').each(function () {
        if ($(this).text().indexOf('ファンクラブに関するご利用ガイドはこちら') > -1) {
            $(this).text('ファンサイトに関するご利用ガイドはこちら');
        }
    });
}

function com_tokutei() {
    $('.link_fc').each(function () {
        let $link = $(this),
        href = $link.attr('href');
                
        setTimeout(function () {
            if (href.indexOf('fc_tokutei') > -1) {
                if (TestSite.indexOf(host) != -1) {
                    $link.attr('href', '//fc.stage-toukenranbu.axdv.me/info/tokutei/');
                } else {
                    $link.attr('href', '//fc.stage-toukenranbu.jp/info/tokutei/');
                }
            } 
        }, 100);
    });

    $('.link_ec').each(function () {
        let $link = $(this),
        href = $link.attr('href');
                
        setTimeout(function () {
            if (href.indexOf('tokutei') > -1) {
                if (TestSite.indexOf(host) != -1) {
                    $link.attr('href', '//ec.stage-toukenranbu.axdv.me/info/tokutei/');
                } else {
                    $link.attr('href', '//ec.stage-toukenranbu.jp/info/tokutei/');
                }
            } 
        }, 100);
    });
}

function com_contact() {
    $('.link_fc').each(function () {
        if ($(this).text().indexOf('ファンクラブに関するお問合せはこちら') > -1) {
            $(this).text('ファンサイトに関するお問合せはこちら');
        }

        let $link = $(this),
                href = $link.attr('href');
            
            setTimeout(function () {
                if (href.indexOf('contact') > -1) {
                    if (TestSite.indexOf(host) != -1) {
                        $link.attr('href', '//store-rev.modd.com/v2/help/fc_contact.aspx?ccode=TOKN');
                    } else {
                        $link.attr('href', '//system.stage-toukenranbu.jp/v2/help/fc_contact.aspx?ccode=TOKN');
                    }
                } 
            }, 100);
    });
}

function CheckOut() {
    $('.link_ec').each(function () {
        let $link = $(this),
            href = $link.attr('href');
        
        setTimeout(function () {
            if (href.indexOf('help04') > -1) {
                if (TestSite.indexOf(host) != -1) {
                    $link.attr('href', '//fc.stage-toukenranbu.axdv.me/faq/#category_14');
                } else {
                    $link.attr('href', '//fc.stage-toukenranbu.jp/faq/#category_14');
                }
            } else if(href.indexOf('help05') > -1) {
                if (TestSite.indexOf(host) != -1) {
                    $link.attr('href', '//fc.stage-toukenranbu.axdv.me/faq/#category_16');
                } else {
                    $link.attr('href', '//fc.stage-toukenranbu.jp/faq/#category_16');
                }
            } else if(href.indexOf('kiyaku') > -1) {
                if (TestSite.indexOf(host) != -1) {
                    $link.attr('href', '//ec.stage-toukenranbu.axdv.me/info/kiyaku/');
                } else {
                    $link.attr('href', '//ec.stage-toukenranbu.jp/info/kiyaku/');
                }
            } else if(href.indexOf('privacy') > -1) {
                if (TestSite.indexOf(host) != -1) {
                    $link.attr('href', '//store-rev.modd.com/v2/help/privacy.aspx?ccode=TOKN');
                } else {
                    $link.attr('href', '//system.stage-toukenranbu.jp/v2/help/privacy.aspx?ccode=TOKN');
                }
            }
        }, 100);
    });

    $('.link_def').attr('href', '//fc.stage-toukenranbu.jp/faq/');
    $('.t_message_center').after('<div class="al-c"><label><input type="checkbox" id="check_kiyaku">利用規約に同意する</label></div>');
    $('#OrderConfBtn_lnk').css({'pointer-events':'none','opacity':'0.5'});
    $(document).on('click','#check_kiyaku',function() {
        if($(this).prop('checked')) {
            $('#OrderConfBtn_lnk').css({'pointer-events':'all','opacity':'1'});
        }else {
            $('#OrderConfBtn_lnk').css({'pointer-events':'none','opacity':'0.5'});
        }
    })
}